<template>
  <div class="flex items-center">
    <span v-if="!hasDiscount || hasCustomerPass" class="mr-2">
      {{ priceLabel }}
    </span>

    <template v-else>
      <OTooltip>
        {{ discountLabel }} ({{ $t('general.discounted') }})

        <template #content>
          <div>
            <p v-if="hasVoucher">
              {{  $t('general.voucher') }} - {{ service.voucher.name }} <template v-if="service.voucher.isDiscountTypeFixed"> {{ $auth.info.location.currencySymbol }}</template>{{ service.voucher.discountAmount }}<template v-if="service.voucher.isDiscountTypePercentage">%</template>
            </p>

            <template v-if="service.discounts && service.discounts.length > 0">
              <span v-for="discount in service.discounts" :key="discount.idReservationServiceDiscount">
                <p v-if="discount.isSourceAssociation">
                  {{  $t('general.addOnDiscount') }} - <template v-if="discount.isTypeFixed"> {{ $auth.info.location.currencySymbol }}</template>{{ discount.amount }}<template v-if="discount.isTypePercentage">%</template>
                </p>
              </span>
            </template>
          </div>
        </template>
      </OTooltip>
    </template>
  </div>
</template>

<script setup lang="ts">
import { OTooltip } from '~/components/elements'

const { $currency } = useNuxtApp()

interface Props {
  service: Record<string, any>
}

const props = defineProps<Props>()

const hasDiscount = computed(() => props.service.discount || props.service.customerPass || props.service.discounts?.length > 0)
const hasCustomerPass = computed(() => props.service.customerPass)
const hasVoucher = computed(() => props.service.voucher)

const discountLabel = computed(() => {
  let price = props.service.price

  if (props.service.discountTotal) {
    price -= props.service.discountTotal
  }

  return $currency.format(price)
})

const priceLabel = computed(() => {
  return $currency.format(props.service.price)
})
</script>
